/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface PromptGetResponse
 */
export interface PromptGetResponse {
    /**
     * 
     * @type {string}
     * @memberof PromptGetResponse
     */
    prompt: string;
}

export function PromptGetResponseFromJSON(json: any): PromptGetResponse {
    return {
        'prompt': json['prompt'],
    };
}

export function PromptGetResponseToJSON(value?: PromptGetResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'prompt': value.prompt,
    };
}


